import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import UserLayout from '../layouts/UserLayout';

// Lazy load features
const OverviewPage = React.lazy(() => import('../features/home/OverviewPage'));
const MatchesPage = React.lazy(() => import('../features/matches/MatchesPage'));
const VenuesPage = React.lazy(() => import('../features/venues/VenuesPage'));
const VenueDetailsPage = React.lazy(() => import('../features/venues/VenueDetailsPage'));
const TransactionsPage = React.lazy(() => import('../features/finance/TransactionsPage'));
const ShopPage = React.lazy(() => import('../features/shop/ShopPage'));
const CheckoutPage = React.lazy(() => import('../features/shop/CheckoutPage'));
const OrderHistoryPage = React.lazy(() => import('../features/shop/OrderHistoryPage'));
const SettingsPage = React.lazy(() => import('../features/settings/SettingsPage'));
const MatchDetailsPage = React.lazy(() => import('../features/matches/MatchDetailsPage'));
const CompetitionsPage = React.lazy(() => import('../features/competitions/CompetitionsPage'));
const UserLeagueDetailPage = React.lazy(() => import('../features/competitions/UserLeagueDetailPage'));
const ReferralsPage = React.lazy(() => import('../features/referrals/ReferralsPage'));
const BecomeOrganizerPage = React.lazy(() => import('../features/organizer/BecomeOrganizerPage'));
const CreateGamePage = React.lazy(() => import('../features/organizer/CreateGamePage'));
const EditGamePage = React.lazy(() => import('../features/organizer/EditGamePage'));
const MyGamesPage = React.lazy(() => import('../features/organizer/MyGamesPage'));
const MyVenuesPage = React.lazy(() => import('../features/organizer/MyVenuesPage'));
const MyVenueFormPage = React.lazy(() => import('../features/organizer/MyVenueFormPage'));
const OrganizerPitchDetailPage = React.lazy(() => import('../features/venues/PitchDetailPage'));
const PayoutSettingsPage = React.lazy(() => import('../features/organizer/PayoutSettingsPage'));
const PayoutHistoryPage = React.lazy(() => import('../features/organizer/PayoutHistoryPage'));
const ReviewsPage = React.lazy(() => import('../features/reviews/ReviewsPage'));
const ProBenefitsPage = React.lazy(() => import('../features/pro/ProBenefitsPage'));

const UserRouter: React.FC = () => {
    // Router configuration for user dashboard
    return (
        <Routes>
            <Route element={<UserLayout />}>
                <Route path="/" element={<OverviewPage />} />
                <Route path="/matches" element={<MatchesPage />} />
                <Route path="/appointments" element={<Navigate to="/dashboard/matches" replace />} />
                <Route path="/bookings" element={<Navigate to="/dashboard/matches?tab=completed" replace />} />
                <Route path="/matches/:id" element={<MatchDetailsPage />} />
                <Route path="/venues" element={<VenuesPage />} />
                <Route path="/venues/:id" element={<VenueDetailsPage />} />
                <Route path="/wallet" element={<TransactionsPage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/shop/checkout" element={<CheckoutPage />} />
                <Route path="/shop/orders" element={<OrderHistoryPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/competitions" element={<CompetitionsPage />} />
                <Route path="/competitions/:id" element={<UserLeagueDetailPage />} />
                <Route path="/referrals" element={<ReferralsPage />} />
                <Route path="/organizer" element={<BecomeOrganizerPage />} />
                <Route path="/my-games" element={<MyGamesPage />} />
                <Route path="/my-games/create" element={<CreateGamePage />} />
                <Route path="/my-games/:id/edit" element={<EditGamePage />} />
                <Route path="/my-venues" element={<MyVenuesPage />} />
                <Route path="/my-venues/new" element={<MyVenueFormPage />} />
                <Route path="/my-venues/:id/edit" element={<MyVenueFormPage />} />
                <Route path="/my-venues/:id" element={<OrganizerPitchDetailPage />} />
                <Route path="/payouts" element={<PayoutHistoryPage />} />
                <Route path="/payout-settings" element={<PayoutSettingsPage />} />
                <Route path="/reviews" element={<ReviewsPage />} />
                <Route path="/pro" element={<ProBenefitsPage />} />

                {/* Redirect unknown routes to dashboard home */}
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Route>
        </Routes>
    );
};

export default UserRouter;
